import {useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {getPaymentOption} from '../../../create/core/_request'
import {ISelectPaymentOption} from '../../../../../coreGlobal/models/default'
import {useRecurrentPayment} from '../core/recurrentPaymentProvider'
import {formatMask} from '../../../../../utils/formatMonetaryToBr'
import {PageOverlayer} from '../../../../../components/PageOverlayer'
import Swal from 'sweetalert2'

const AUTOMATIC_PAYMENTS = [1, 2, 3, 4, 5]
// Cartão de crédito à vista/parcelado (sem recorrência): pago pelo link de pagamento da cobrança
const ENABLED_AUTOMATIC_PAYMENTS = [2]
const VOUCHER_PAYMENT = 5

const isManualPayment = (value) => !AUTOMATIC_PAYMENTS.includes(Number(value))
const isEnabledAutomaticPayment = (value) => ENABLED_AUTOMATIC_PAYMENTS.includes(Number(value))

const methodSize = (length, index) => {
  if (index == 0 && length === 1) {
    return 'col-10 p-0'
  }

  if (index == 0 && length != 0) {
    return 'col-12 p-0'
  }

  if (index != 0 && index < length - 1) {
    return 'col-10 p-0'
  }

  return 'col-7 p-0'
}

const SwitchAction = ({position, length, addMethodPayment, removeMethodPayment}) => {
  if (position === 1 && length > 1) return <></>
  if (position == 1 && length == 1) {
    return (
      <div className='col-2 p-0 d-flex align-items-center justify-content-center '>
        <span
          onClick={() => addMethodPayment()}
          className='btn btn-light-danger font-weight-bold w-auto'
        >
          <KTIcon iconName='plus' className='svg-icon svg-icon-danger' />
        </span>
      </div>
    )
  }

  if (position !== 0 && position !== length) {
    return (
      <div className='col-2 p-0 d-flex align-items-center justify-content-center '>
        <span
          onClick={() => removeMethodPayment()}
          className='btn btn-light-danger font-weight-bold w-auto'
        >
          <KTIcon iconName='trash' className='svg-icon svg-icon-danger' />
        </span>
      </div>
    )
  }

  if (position !== 0 && position === length) {
    return (
      <>
        <div className='col-2 p-0 ms-2 me-2 d-flex align-items-center justify-content-center '>
          <span
            onClick={() => addMethodPayment()}
            className='btn btn-light-danger font-weight-bold w-auto'
          >
            <KTIcon iconName='plus' className='svg-icon svg-icon-danger' />
          </span>
        </div>
        <div className='col-2 p-0 d-flex align-items-center justify-content-center '>
          <span
            onClick={() => removeMethodPayment()}
            className='btn btn-light-danger font-weight-bold w-auto'
          >
            <KTIcon iconName='trash' className='svg-icon svg-icon-danger' />
          </span>
        </div>
      </>
    )
  }
}

export const PaymentRecurrentContainer = () => {
  const [paymentOption, setStates] = useState<ISelectPaymentOption[] | undefined>([])
  const [loadingPage, setLoadingPage] = useState(false)
  const [optionInstallment, setOptionInstallment] = useState<number[]>([])

  useEffect(() => {
    async function init() {
      try {
        setLoadingPage(true)
        const data = await getPaymentOption()
        const arrayPayment = data?.filter(
          (val) => isManualPayment(val.value) || isEnabledAutomaticPayment(val.value)
        )
        setStates(arrayPayment)

        if (arrayPayment && arrayPayment.length > 0) {
          handlePaymentDefault(
            arrayPayment.find((val) => isManualPayment(val.value)) ?? arrayPayment[0]
          )
        }
      } catch (error: any) {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error?.response?.data?.message,
          timer: 2000,
        })
      } finally {
        setLoadingPage(false)
      }
    }

    init()
  }, [])
  const {
    payment,
    setPayment,
    handleChangeTypeMethodPayment,
    handleChangeValueMethodPayment,
    handleChangeInstallments,
    checkPaymentMethod,
  } = useRecurrentPayment()

  function handlePaymentDefault(dta: any) {
    let newData = [...payment]
    newData[0] = {
      ...payment[0],
      method: dta.value,
      value: 0,
      numberOfInstallments: dta.value == 3 ? 2 : 1,
      hasInstallment: dta.installment_enabled,
      recurrency: dta.value === 3,
    }
    setPayment(newData)
    setOptionInstallment(Array.from({length: Number(dta.numberInstallment)}, (_, i) => i + 1))
  }

  const hasInstallment = (id, index, e) => {
    const data = paymentOption?.find((val) => {
      return val.value == id && val.installment_enabled == true
    })

    if (data !== undefined) {
      handleChangeTypeMethodPayment(index, e, true)
      const installmentsArray = Array.from(
        {length: Number(data?.numberInstallment)},
        (_, i) => i + 1
      )
      setOptionInstallment(installmentsArray)
      return
    }

    handleChangeTypeMethodPayment(index, e, false)
  }

  return (
    <>
      {loadingPage ? (
        <PageOverlayer />
      ) : (
        payment?.map((pay, index) => {
          const paymentMethodSize = methodSize(payment.length, index)
          return (
            <>
              <div className='mb-8 w-100'>
                <div className='row m-0 col-12'>
                  <div className={paymentMethodSize}>
                    <select
                      className='form-select form-select-lg form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark'
                      value={pay.method}
                      onChange={(e) => {
                        hasInstallment(e.target.value, index, e)
                      }}
                    >
                      {paymentOption?.some((option) => isManualPayment(option.value)) && (
                        <optgroup label='Manuais:'>
                          {paymentOption
                            .filter((option) => isManualPayment(option.value))
                            .map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                        </optgroup>
                      )}
                      {paymentOption?.some((option) => isEnabledAutomaticPayment(option.value)) && (
                        <optgroup label='Automáticos:'>
                          {paymentOption
                            .filter((option) => isEnabledAutomaticPayment(option.value))
                            .map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                        </optgroup>
                      )}
                    </select>
                  </div>
                </div>
                <div className='row mt-2 m-0'>
                  <div className={'col-8 p-0'}>
                    <label>Valor:</label>
                    <input
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark col-5'
                      value={formatMask(pay.value)}
                      onChange={(e) => {
                        handleChangeValueMethodPayment(index, formatMask(e.target.value))
                      }}
                    />
                  </div>
                  {pay.hasInstallment && pay.method != VOUCHER_PAYMENT && (
                    <div className='col-4 p-0 ps-2'>
                      <label>N. Parcelas:</label>
                      <select
                        className='form-select form-select-lg form-control form-control-lg form-control-solid mb-3 mb-lg-0 border border-dark'
                        value={pay.numberOfInstallments}
                        onChange={(e) => handleChangeInstallments(index, e.target.value)}
                      >
                        {optionInstallment.map((val) => (
                          <option key={`numberPlots-${pay.paymentRef}-${val}-${index}`} value={val}>
                            {val}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>
            </>
          )
        })
      )}
    </>
  )
}
